import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {constants, responseSelector} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {
  equipoEditDuck,
  equipoEditThunk,
  equipoGetDuck,
  equipoGetThunk,
} from './duck';
import {EquipoCreateView} from './EquipoCreateView';

export const EquipoEdit = ({history, match, token}) => {
  const equipoId = match.params.equipoId;

  const dispatch = useDispatch();
  const {topAlert, setTopAlert, submitAlert, setSubmitAlert} = useAlerts();

  const equipoGet = useSelector(state => state.equipoGet);
  const equipoEdit = useSelector(state => state.equipoEdit);

  const [nombre, setNombre] = useState('');
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(equipoGet);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(equipoGetDuck.actions.clear());
    }

    if (data) {
      dispatch(equipoGetDuck.actions.clear());

      const equipo = data.equipo;

      setNombre(equipo.nombre);
      setUsuarios(equipo.integrantes || []);
    }
  }, [equipoGet]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(equipoEdit);

    if (error) {
      setSubmitAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(equipoEditDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      setSubmitAlert({
        text: 'Equipo editado correctamente',
        type: alertTypes.success,
        closable: false,
      });

      dispatch(equipoEditDuck.actions.clear());
    }
  }, [equipoEdit]);

  useEffect(() => {
    dispatch(
      equipoGetThunk({
        idNumerico: equipoId,
        userToken: token.raw,
      }),
    );
  }, []);

  const submit = () => {
    let data = {
      idNumerico: equipoId,
      userToken: token.raw,
      nombre,
      integrantes: usuarios,
    };

    log({'submit.data': data});

    dispatch(equipoEditThunk(data));
  };

  return (
    <EquipoCreateView
      mode="create"
      history={history}
      equipoGet={equipoGet}
      equipoCreate={equipoEdit}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      nombre={nombre}
      setNombre={setNombre}
      usuarios={usuarios}
      setUsuarios={setUsuarios}
      token={token}
    />
  );
};
